module.exports = __webpack_public_path__ + "static/media/newsImage1.d6fcae65.webp";